/**
 * Redux store configuration.
 * Combines all slices and sets up Redux-Saga middleware.
 */
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import gameReducer from './slices/gameSlice';
import keyboardReducer from './slices/keyboardSlice';
import dictionaryReducer from './slices/dictionarySlice';
import appReducer from './slices/appSlice';
import rootSaga from './sagas/gameSaga';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    game: gameReducer,
    keyboard: keyboardReducer,
    dictionary: dictionaryReducer,
    app: appReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

// Run root saga
sagaMiddleware.run(rootSaga);

export default store;
